import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {fromJS} from "immutable";
import Form, {prepareValuesForSubmission, tagsToString, validateForm} from "./OrderTaggingRuleForm";
import {cancelEditOrderTaggingRule, requestDeleteOrderTaggingRule} from "../../actions/ShippingApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {ORDER_TAGGING_RULE} from "../../queries/shipping";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";


class EditOrderTaggingRuleFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    const updatedValues = prepareValuesForSubmission(values).set("ruleId", this.props.ruleId);

    return this.props.updateShippingOrderTaggingRule(updatedValues.toJS())
      .then((response) => {
        if (response.data.updateShippingOrderTaggingRule.errors.length <= 0) {
          // Success
          this.handleCancel();
        } else {
          let errors = createValidationErrors(response.data.updateShippingOrderTaggingRule.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });
  }

  handleCancel() {
    this.props.cancelEditOrderTaggingRule(this.props.ruleId);
  }

  handleDelete() {
    this.props.requestDeleteOrderTaggingRule(this.props.ruleId);
  }

  render() {
    const {loading, error, shippingOrderTaggingRule: rule} = this.props.data;

    if (loading) return <Loading />;
    if (error) return <GraphQLErrors error={error} />;

    const initialValues = fromJS({
      title: rule.title,
      accountId: rule.accountId,
      orderTypes: rule.orderTypes,
      skuPattern: rule.skuPattern,
      tags: tagsToString(rule.tags),
      status: rule.status,
    });

    return (
      <Form
        {...this.props}
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        onDelete={this.handleDelete.bind(this)}
        showDelete={true}
        />
    )
  }
}

const UPDATE_ORDER_TAGGING_RULE = gql`
  mutation updateShippingOrderTaggingRule($data: UpdateShippingOrderTaggingRuleInput!) {
    updateShippingOrderTaggingRule(input: $data) {
      errors { key message }
    }
  }
`;

const withQuery = compose(
  graphql(ORDER_TAGGING_RULE, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        ruleId: props.ruleId,
      },
    })
  }),
  graphql(UPDATE_ORDER_TAGGING_RULE, {
    props: ({ mutate }) => ({
      updateShippingOrderTaggingRule: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelEditOrderTaggingRule, requestDeleteOrderTaggingRule})(withQuery(EditOrderTaggingRuleFormContainer));
